import { Component, OnInit } from '@angular/core';
import { Location } from '../../../models/location';
import { Company } from '../../../models/company';
import { Category } from '../../../models/category';
import { Page } from '../../../models/paging/page';
import { Equipment } from '../../../models/equipment';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { CategoryService } from '../../../services/category.service';
import { EquipmentService } from '../../../services/equipment.service';
import { Router } from '@angular/router';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
  selector: 'app-equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.css']
})
export class EquipmentComponent implements OnInit {

  filter: any = {
    company_Id: 0,
    location_Id: 0,
    category_Id: 0,
    serial_Num: '',
    asset_Num: ''
  };

  locationList: Location[];

  companies: Company[];
  locations: Location[];
  init: boolean;
  categories: Category[];

  page = new Page();
  rows = Array<Equipment>();

  constructor(public companyService: CompanyService, public locationService: LocationService, public categoryService: CategoryService,
    public equipmentService: EquipmentService, public router: Router) {

    this.page.pageNumber = 0;
    this.page.size = 10;

/*    companyService.getAll().then((data) => {
      this.companies = data;
    });*/

    /*locationService.getAll().then((data) => {
      this.locationList = data;
      this.locations = this.locationList;
    });*/

    categoryService.getAll().then((data) => {
      this.categories = data;
    });
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
    this.init = true;
  }

  edit(row) {
    this.router.navigate(['administration/equipment/manage'], { queryParams: { id: row.id } });
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.equipmentService.getResults(this.page, this.filter.insurer_Id, this.filter.broker_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.category_Id, this.filter.serial_Num, this.filter.asset_Num).then((pagedData) => {
      this.page = pagedData.page;
        this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
    });
  }

  generateExcel() {
    this.equipmentService.getExcel(this.page, this.filter.insurer_Id, this.filter.broker_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.category_Id, this.filter.serial_Num, this.filter.asset_Num).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
